module.exports = __webpack_public_path__ + "static/img/P4.c6d442e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mszj/P4.png
// module id = jRGL
// module chunks = 0